import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';
import { useIsMutating } from '@tanstack/react-query';

import { WithRef } from 'support/types/withRef';
import { Button } from 'components/Form/Button/Button';

import { FieldAnnotationPopoverShell } from '../../FieldAnnotationPopoverShell';

export const ErrorsResolved = ({ ref, style }: WithRef<{ style?: React.CSSProperties }, HTMLDivElement>) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();
  const { t } = useTranslation();
  const isMutating = useIsMutating();

  return (
    <FieldAnnotationPopoverShell
      ref={ref}
      style={style}
      status="fixed"
      title={t('webedi:fieldAnnotation.errorsResolved.title')}
      description={t('webedi:fieldAnnotation.errorsResolved.description')}
      actions={
        <Button
          type="submit"
          size="small"
          fullWidth
          LeftIcon={PaperAirplaneIcon}
          form="webedi-document"
          onMouseDown={(e) => e.preventDefault()}
          loading={Boolean(isMutating || isSubmitting)}
          analyticsId="webedi:document_send"
        >
          {t('webedi:fieldAnnotation.errorsResolved.cta')}
        </Button>
      }
    />
  );
};
